import * as React from "react";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  CardTitle,
  CardBody,
  Card,
  Row,
  Col,
  Button,
  CardColumns
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { Loading } from "../Loading";
import { withTranslation } from "react-i18next";

import { orderAction } from "../../_actions";
import { orderConstants } from "../../_constants";
import { PayOrderModal } from "./PayOrderModal";
import { CancelOrderModal } from "./CancelOrderModal";

class OrderDetail extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    const { match } = this.props;
    const orderId = match.params.id;
    this.props.load(orderId);
  }

  componentDidUpdate(prevProps: any) {
    if (
      this.props.order.loading != prevProps.order.loading &&
      this.props.order.loading
    ) {
      const { match } = this.props;
      const orderId = match.params.id;
      this.props.load(orderId);
    }
  }

  formatDate(date: any, lang: any) {
    let day = date.slice(8, 10);
    let month = date.slice(5, 7);
    let year = date.slice(0, 4);
    switch (lang) {
      case "cs":
        day = day[0] == 0 ? day[1] : day;
        month = month[0] == 0 ? month[1] : month;
        return day + ". " + month + ". " + year;
      default:
        return month + "/" + day + "/" + year;
    }
  }

  createRow(caption: any, data: any, lang?: any) {
    return (
      <Row>
        <Col xs="12">
          <Row className="label" style={{ fontWeight: "bold" }}>
            <Col xs="12">{caption}</Col>
          </Row>
          {lang ? (
            <Row>
              <Col xs="12" className="mb-2">
                {data ? this.formatDate(data, lang) : "-"}
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xs="12" className="mb-2">
                {data ? data : "-"}
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    );
  }

  isAdmin() {
    const { authentication } = this.props;
    let admin = false;

    authentication &&
      (authentication.user &&
        (authentication.user.roles &&
          authentication.user.roles.map((role: any) => {
            role == "Admin" && (admin = true);
          })));

    return admin;
  }

  isOnlinePayment(isOnline: boolean, lang: any) {
    if (lang == "cs") {
      return isOnline ? "Ano" : "Ne";
    }
    if (lang == "en") {
      return isOnline ? "Yes" : "No";
    }
  }

  canBeCanceled(id: any) {
    if (!this.isAdmin()) return false;
    if (id == orderConstants.ORDER_ID_WAITING) return true;
    if (id == orderConstants.ORDER_ID_CREATED) return true;
    return false;
  }

  canPay(id: any) {
    if (id == orderConstants.ORDER_ID_PAID) return false;

    if (id == orderConstants.ORDER_ID_CANCELED) {
      if (this.isAdmin()) {
        return true;
      } else {
        return false;
      }
    }

    return true;
  }

  render() {
    const { order, loading, t } = this.props;
    const lang = localStorage.getItem("i18nextLng");

    if (loading || order.data == []) {
      return <Loading />;
    }

    if (!order.data.address) {
      return <Loading />;
    }

    if (!order.data.licence) {
      return <Loading />;
    }

    return (
      <Container>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/">Sypal</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/order-list">{t("order_list")}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>{t("order_detail")}</BreadcrumbItem>
        </Breadcrumb>
        <Row style={{ margin: "0" }}>
          <div
            style={{
              float: "right",
              margin: "0 0 20px 0",
              width: "100%",
              display: "inlineFlex"
            }}
          >
            <Button style={{ float: "right", marginLeft: "5px" }}>
              <a
                href={`${CONFIG.ApiSettings.url}/api/invoice/proforma/${order.data.id}`}
                target="blank"
                download
              >
                {t("actions.proforma")}
              </a>
            </Button>

            {order.data.orderStateId == orderConstants.ORDER_ID_PAID && (
              <Button style={{ float: "right" }}>
                <a
                  href={`${CONFIG.ApiSettings.url}/api/invoice/${order.data.id}`}
                  target="blank"
                  download
                >
                {t("actions.invoice")}
                </a>
              </Button>
            )}

            {this.canPay(order.data.orderStateId) && (
              <PayOrderModal
                buttonLabel={t("actions.pay_order")}
                id={order.data.id}
                variableSymbol={order.data.variableSymbol}
                currency={order.data.currency}
                price={order.data.price}
                name={order.data.licenceType.name}
                canceled={
                  order.data.orderStateId == orderConstants.ORDER_ID_CANCELED
                }
              />
            )}
          </div>
        </Row>
        <div className="order-detail">
          <Row xs="12" style={{ paddingBottom: "30px" }}>
            <Col xs="12" sm="12" md="6" lg="6">
              <Card className="mb-4">
                <CardBody>
                  <Row>
                    <Col xs="12">
                      {this.createRow(t('company_name'), order.data.address.companyName)}
                      {this.createRow(t("street"), order.data.address.street)}
                      {this.createRow(t("town"), order.data.address.town)}
                      {this.createRow(t("zip"), order.data.address.zipCode)}
                      {this.createRow(t("vat"), order.data.address.vatNumber)}
                      {this.createRow(t("id"), order.data.address.identificationNumber)}
                      {this.createRow(t("country"), order.data.address.country)}
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className="mb-4">
                <CardBody>
                  <Row>
                    <Col xs="12">
                      {this.createRow(t("email"), order.data.address.email)}
                      {this.createRow(t("phone"), order.data.address.phoneNumber)}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col xs="12" sm="12" md="6" lg="6">
              <Card className="mb-4">
                <CardBody>
                  <Row>
                    <Col xs="12">
                      {this.createRow(t("licence_name"), order.data.licenceType.name)}
                      {this.createRow(t("valid_from"), order.data.validFrom, lang)}
                      {this.createRow(t("valid_to"), order.data.validTo, lang)}
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className="mb-4">
                <CardBody>
                  <Row>
                    <Col xs="12">
                      {this.createRow(t("variable_symbol"), order.data.variableSymbol)}
                      {this.createRow(t("online_payment"), this.isOnlinePayment(order.data.isOnlinePayment, lang))}
                      {this.createRow(t("price"), order.data.price + " " + order.data.currency)}
                      {this.createRow(t("order_state"),
                        lang == "en" ? order.data.orderStateLocalized : order.data.orderState)}
                      {this.createRow(t("order_created"), order.data.created, lang)}
                      {this.createRow(t("payment_date"), order.data.paid, lang)}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>

        {this.canBeCanceled(order.data.orderStateId) && (
          <div>
            <CancelOrderModal id={order.data.id} buttonLabel={t("actions.cancel_order")} />
          </div>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    order: state.order,
    authentication: state.authentication
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      load: orderAction.loadOrder
    },
    dispatch
  );
};

const OrderDetailComponent = compose (
  withTranslation('orders'),
  connect(
  mapStateToProps,
  mapDispatchToProps
))(OrderDetail)

export { OrderDetailComponent as OrderDetail };
